import { isValidElement } from "react";
import { isPlainObject } from "../../utils/index.js";
function isValidActionBarItem(value) {
  if (!isValidElement(value)) return false;
  const item = value.props;
  if (!isPlainObject(item)) return false;
  if (!item.hasOwnProperty("icon")) return false;
  if (!item.hasOwnProperty("label")) return false;
  const { icon, label } = item;
  let _internal;
  if (item.hasOwnProperty("_internal")) {
    if (!isValidInternal(item._internal)) return false;
    _internal = item._internal;
  }
  let mode;
  if (item.hasOwnProperty("mode")) {
    if (typeof item.mode !== "string") return false;
    mode = item.mode;
  }
  let disabled;
  if (item.hasOwnProperty("disabled")) {
    if (typeof item.disabled !== "boolean") return false;
    disabled = item.disabled;
  }
  let onClick;
  if (item.hasOwnProperty("onClick")) {
    if (typeof item.onClick !== "function") return false;
    onClick = item.onClick;
  }
  let color;
  if (item.hasOwnProperty("color")) {
    if (typeof item.color !== "string") return false;
    color = item.color;
  }
  let id;
  if (item.hasOwnProperty("id")) {
    if (typeof item.id !== "string") return false;
    id = item.id;
  }
  let disableInteraction;
  if (item.hasOwnProperty("disableInteraction")) {
    if (typeof item.disableInteraction !== "boolean") return false;
    disableInteraction = item.disableInteraction;
  }
  let testId;
  if (item.hasOwnProperty("testId")) {
    if (typeof item.testId !== "string") return false;
    testId = item.testId;
  }
  let className;
  if (item.hasOwnProperty("className")) {
    if (typeof item.className !== "string") return false;
    className = item.className;
  }
  let tooltip;
  if (item.hasOwnProperty("tooltip")) {
    tooltip = item.tooltip;
  }
  let sx;
  if (item.hasOwnProperty("sx")) {
    if (typeof item.sx !== "object") return false;
    sx = item.sx;
  }
  let divider;
  if (item.hasOwnProperty("divider")) {
    if (typeof item.divider !== "boolean") return false;
    divider = item.divider;
  }
  const obj = {
    id,
    sx,
    mode,
    icon,
    label,
    color,
    testId,
    className,
    tooltip,
    onClick,
    disabled,
    _internal,
    disableInteraction,
    divider
  };
  const isValid = obj;
  return !!isValid;
}
function isValidInternal(value) {
  if (!isPlainObject(value)) return false;
  if (!value.hasOwnProperty("size")) return false;
  if (!value.hasOwnProperty("menuMode")) return false;
  if (!value.hasOwnProperty("parentOnClick")) return false;
  if (!value.hasOwnProperty("renderInTruncateList")) return false;
  if (!value.hasOwnProperty("gap")) return false;
  const item = value;
  const { menuMode, parentOnClick, size, gap, renderInTruncateList } = item;
  const obj = { menuMode, parentOnClick, size, gap, renderInTruncateList };
  const isValid = obj;
  const noNewOptionalProps = {};
  return !!isValid && !!noNewOptionalProps;
}
export {
  isValidActionBarItem
};
//# sourceMappingURL=guards.js.map
